import React, {Component} from 'react';
import TextField from 'material-ui/lib/text-field';
import SelectField from 'material-ui/lib/select-field';
import MenuItem from 'material-ui/lib/menus/menu-item';
import Toggle from 'material-ui/lib/toggle';
import RaisedButton from 'material-ui/lib/raised-button';

export default class Question extends Component{

  // constructor(props) {
  //   super(props);
  //   this.state = {question_text:'',
  //             type:'Subjective',
  //             id:'',
  //             number:this.props.number};
  // }


  mcq_style = {
    display:"none"
  }

  slider_style = {
    display:"none"
  }

  // state = {question_text:'',
  //           type:'Subjective',
  //           id: this.dateObj.getTime(),
  //           number:this.props.number,
  //           mcq_options:['','','',''],
  //           slider_options:['1:10',['','','']]
  //         };

  state = this.props.passedState;
  main_id = this.state.id;

  handleQuestionTextChange = (e) => {
     //console.log("Question: " + e.target.value);
     this.state.question_text = e.target.value;
     //console.log(this.state);
     //console.log(e);
     this.props.onStateChange(this.state);
   };

   handleToggleChange = () =>{

   }

   handleMcqOptionChange = (number, e) => {
     var temp = this.state;
     temp.mcq_options[parseInt(number)-1] = e.target.value;
     this.setState(temp);
     //console.log(this.state);
     this.props.onStateChange(this.state);
   }

   handleSliderValueChange = (e) => {
     var temp = this.state;
     temp.slider_options[0] = e.target.value;
     this.setState(temp);
     //console.log(this.state);
     this.props.onStateChange(this.state);
   }

   handleSliderOptionChange = (number, e) => {
     var temp = this.state;
     temp.slider_options[1][number] = e.target.value;
     this.setState(temp);
     //console.log(this.state);
     this.props.onStateChange(this.state);
   }

   deleteSelf = () => {
     this.props.deleteSelf(this.state.timestamp);
   }

   handleTypeChange = (e, index, value) => {
     //console.log(e.target.innerHTML);
     //console.log('type: '+ index);
     //this.state.type = value;
     var temp = this.state;
     temp.type=value;
     this.setState(temp);
     this.props.onStateChange(this.state);
      //   this.setState({question_text:this.state.question_text,
      //            type:value,
      //            id:this.state.id,
      //console.log(this.state);
      //            number:this.props.number});
      if (this.state.type == "MCQ"){
        this.mcq_style.display = "inline";
        this.slider_style.display = "none";
      }
      if (this.state.type == "Subjective"){
        this.mcq_style.display = "none";
        this.slider_style.display = "none";
      }
      if (this.state.type == "Slider"){
        this.mcq_style.display = "none";
        this.slider_style.display = "inline";
      }


    }

    giveState = () => {
      alert(JSON.stringify(this.state));
    }

    handleToggle = () =>{
      //TODO
      if (this.state.type  != "MCQ"){
        alert("Type of the question should be MCQ!");
        return;
      }
      var shouldIToggle = this.props.handleToggle(this.state.timestamp);
      if(shouldIToggle){
        var temp = this.state;
        temp.isToggled = !temp.isToggled;
        this.setState(temp);
      }
    }

  render(){
    return(
      //Question text
      <div>
        <div className="well well-sm">

          Type:&nbsp;&nbsp;&nbsp;&nbsp;
          <SelectField value={this.state.type} onChange={this.handleTypeChange} underlineStyle={{color:"blue"}}>
            <MenuItem value={"Subjective"} primaryText="Subjective"/>
            <MenuItem value={"MCQ"} primaryText="MCQ"/>
            <MenuItem value={"Slider"} primaryText="Slider"/>
          </SelectField>

          <RaisedButton label="Remove" secondary={true} onClick={this.deleteSelf} style={{maxWidth:150,float:"right"}} />
          <Toggle onToggle={this.handleToggle} toggled={this.state.isToggled} label={"Conflicting?"} style={{maxWidth:150,float:"right",paddingRight:20,paddingTop:10}} />
          <br />

          Question:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <TextField id="" hintText="Type your question here." fullWidth={true} onChange={this.handleQuestionTextChange.bind(this)} /><br/>
          <br />

          <div id={this.id + "mcq_options"} className="" style={this.mcq_style}>
            Option 1: &nbsp;&nbsp;&nbsp;&nbsp;
            <TextField style={{width:500}} id={this.main_id+"mcq_option_1"} hintText="Option 1" onChange={this.handleMcqOptionChange.bind(this,"1")} /><br/>
            Option 2: &nbsp;&nbsp;&nbsp;&nbsp;
            <TextField style={{width:500}} id={this.main_id+"mcq_option_2"} hintText="Option 2" onChange={this.handleMcqOptionChange.bind(this,"2")} /><br/>
            Option 3: &nbsp;&nbsp;&nbsp;&nbsp;
            <TextField style={{width:500}} id={this.main_id+"mcq_option_3"} hintText="Option 3" onChange={this.handleMcqOptionChange.bind(this,"3")} /><br/>
            Option 4: &nbsp;&nbsp;&nbsp;&nbsp;
            <TextField style={{width:500}} id={this.main_id+"mcq_option_4"} hintText="Option 4" onChange={this.handleMcqOptionChange.bind(this,"4")} /><br/>
          </div>

          <div id={this.id + "slider_options"} className="" style={this.slider_style}>
            Slider Value: &nbsp;&nbsp;&nbsp;&nbsp;
            <TextField style={{width:100}} id="" hintText="eg. 1:10" onChange={this.handleSliderValueChange.bind(this)} /><br/><br/>
            Left Value: &nbsp;&nbsp;&nbsp;&nbsp;


            <TextField style={{width:200}} id="" hintText="Strongly Agree" onChange={this.handleSliderOptionChange.bind(this,0)} />
            Middle Value: &nbsp;&nbsp;&nbsp;&nbsp;
            <TextField style={{width:200}} id="" hintText="Agree/Disagree" onChange={this.handleSliderOptionChange.bind(this,1)} />
            Right Value: &nbsp;&nbsp;&nbsp;&nbsp;
            <TextField style={{width:200}} id="" hintText="Strongly Disagree" onChange={this.handleSliderOptionChange.bind(this,2)} />
          </div>
          <button style = {{display:"none"}} className="btn btn-sm btn-primary" onClick={this.giveState}>{"State?"}</button>
        </div>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/views/questions/question.js
 **/